import styled from 'foundations-theming/utils';
// @ts-expect-error This library is not yet typed
import { UIAvatar } from 'ui-addon-avatars';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { useIsIdle } from '../utils/useIsIdle';
import TruncateDiv from './TruncateDiv';
import { memo } from 'react';
import { DefaultLinkComponent } from './labels/LabelCell';
import { jsx as _jsx } from "react/jsx-runtime";
const AvatarContainer = styled.div.withConfig({
  displayName: "AvatarCell__AvatarContainer",
  componentId: "sc-1lx0id7-0"
})(["height:24px;width:24px;"]);

// HACK: this targets the inner div `UIAvatar` uses for its avatar to change the
// position property. I don't see any other way to do this looking at the source.
// This is used to keep it from overlapping the sticky checkbox, so if we drop that
// feature we can remove this hack too.
// See https://git.hubteam.com/HubSpot/ui-addon-avatars/blob/master/static/js/UIAvatarDisplay/baseStyledComponents/AvatarWrapper.js
const StyledAvatar = styled(UIAvatar).withConfig({
  displayName: "AvatarCell__StyledAvatar",
  componentId: "sc-1lx0id7-1"
})(["position:static;div{position:static;}"]);
const AvatarPlaceholder = styled.div.withConfig({
  displayName: "AvatarCell__AvatarPlaceholder",
  componentId: "sc-1lx0id7-2"
})(["background-color:", ";border-color:transparent;border-radius:50%;width:100%;height:100%;"], ({
  theme
}) => theme.color['do-not-use-koala']);
export const AvatarCell = ({
  // default to link component here as well in case this component is called externally
  // so that it matches the expected behavior
  LinkComponent = DefaultLinkComponent,
  type,
  id,
  href,
  displayName,
  onClick,
  children,
  className
}) => {
  const isIdle = useIsIdle();
  const lookupProp = {
    [type]: type === 'hubSpotUserEmail' ? id : Number(id)
  };
  const avatar = isIdle && id ? /*#__PURE__*/_jsx(StyledAvatar, Object.assign({
    "data-test-id": "avatar",
    type: type
  }, lookupProp, {
    displayName: displayName,
    size: "xs",
    className: className
  })) : /*#__PURE__*/_jsx(AvatarPlaceholder, {
    "data-test-id": "avatar-placeholder"
  });
  const isClickable = href || onClick;
  return /*#__PURE__*/_jsx(UIMediaObject, {
    align: "center",
    itemLeft: id && avatar,
    MediaLeft: AvatarContainer,
    children: /*#__PURE__*/_jsx(TruncateDiv, {
      children: isClickable ? /*#__PURE__*/_jsx(LinkComponent, {
        role: "link",
        href: href,
        onClick: onClick,
        children: children
      }) : children
    })
  });
};
export default /*#__PURE__*/memo(AvatarCell);